import { PaintConfigurationUrlState } from "@/utils/productConfiguration/visuals/paintConfiguration/paintConfigurator.types";

export const encodePaintConfiguratorUrlState = (
    colorId?: string,
    colorHex?: string,
    colorName?: string
) => {
    if (!colorId || !colorHex || !colorName) {
        return undefined;
    }

    const outPutState: PaintConfigurationUrlState = {
        paintInfo: {
            colorHex,
            colorName,
            colorId
        }
    };

    const encodedState = btoa(encodeURIComponent(JSON.stringify(outPutState)));
    return encodedState;
};
